// src/mocks/handlers/auth/loginHandler.ts

import { rest } from 'msw';
import users from '@/mocks/data/users.json';
import { loginSchema } from './authHandlers.schema';
import {
  LoginRequestBody,
  OtpResponse,
  ErrorResponse,
} from '@/domains/auth/auth.types';
import { API_ENDPOINTS } from '@/services/api/endpoints';
import { VITE_MSW_BASE_URL } from '@/config';

export const loginHandler = rest.post<
  LoginRequestBody,
  OtpResponse | ErrorResponse
>(`${VITE_MSW_BASE_URL}${API_ENDPOINTS.AUTH_LOGIN}`, (req, res, ctx) => {
  const parsedBody = loginSchema.safeParse(req.body);

  if (!parsedBody.success) {
    return res(
      ctx.status(400),
      ctx.json({
        error: 'Invalid request data',
        issues: parsedBody.error.issues,
      }),
    );
  }

  const { email, password } = parsedBody.data;
  const user = users.find((u) => u.email === email && u.password === password);

  if (user) {
    return res(ctx.status(200), ctx.json({ otp: user.otp }));
  }

  return res(ctx.status(401), ctx.json({ error: 'Invalid credentials' }));
});
